module.exports = __webpack_public_path__ + "img/status.ca36115f.svg";